import React from 'react'
import NgrxDate from '../util/NgrxDateHelper'
import { localize, getFullLocale } from '../util/Localizer'
import Config from '../Config'

const TitledLine = (props) => {
  // format the data if required
  let { value, rawTitle, className } = props
  let title = rawTitle ? props.title : localize(props.title)

  switch (props.format) {
    case 'date':
      value = NgrxDate.SetDate(value)
      break
    case 'dateRange':
      value = `${NgrxDate.SetDate(value[0])} ${localize('common.preposition.to')} ${NgrxDate.SetDate(value[1])}`
      if (value.indexOf(Config.defaultDateValue) >= 0) {
        value = Config.defaultDateRange
      }
      break
    case 'currency':
      let curr = Intl.NumberFormat(getFullLocale(), { style: 'currency', currency: 'CAD' }).format(value || 0).replace('CA', '')
      value = (<span>{ curr }</span>)
      break
    default:
      break
  }

  // if it's empty set a default value
  if (value === null || value === undefined || value.length === 0) {
    value = localize('titledLabelNotAvailable')
  }

  // Here we are checking for divs so that we don't put them into a p tag :)
  value = (<span className={`titledLabelLabel ${(className || '').toLowerCase()}`}>{value}</span>)

  // return the component
  return (
    <div>
      <p className='titledLabelTitle'>{title} {value}</p>
    </div>
  )
}

export default TitledLine



// WEBPACK FOOTER //
// ./src/controls/TitledLine.js